import styled from 'styled-components'

const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: rgb(0, 0, 0);
  padding: 0px 6px;
  background: rgba(0, 0, 0, 0.1);
  border: 0px;
  border-radius: 10px;
`

export default Label